module.exports = __webpack_public_path__ + "static/media/envelope-solid.a1b1533c.svg";